import React from "react";
import { useQuery } from "@tanstack/react-query";
import api, { fileUrl } from "../lib/api";
import { usePrimaryPropertyId } from "../hooks/useMyProperties";
import { Loader, SectionHeading, EmptyState } from "../components/Loader";
import { fmtDateTime } from "../lib/format";
import { Megaphone } from "lucide-react";

export default function Updates() {
  const { propertyId, isLoading } = usePrimaryPropertyId();
  const { data: updates = [], isLoading: ul } = useQuery({
    queryKey: ["updates", propertyId], queryFn: async () => (await api.get(`/properties/${propertyId}/updates`)).data, enabled: !!propertyId });

  if (isLoading || ul) return <Loader label="Loading updates" />;

  return (
    <div className="space-y-6 arq-fade-up">
      <SectionHeading overline="Build" title="Project Updates" />
      {updates.length === 0 ? <EmptyState icon={Megaphone} title="No updates yet" subtitle="Your Arqitek team will post updates as your home progresses." /> : (
        <div className="relative space-y-6">
          {updates.map((u) => (
            <article key={u.id} className="bg-arq-card border border-border rounded-md p-6" data-testid={`update-${u.id}`}>
              <div className="flex items-center gap-2 mb-2">
                {u.related_milestone && <span className="text-[10px] uppercase tracking-widest text-arq-accent font-semibold">{u.related_milestone}</span>}
                <span className="text-[10px] uppercase tracking-wider text-muted-foreground ml-auto">{fmtDateTime(u.date)}</span>
              </div>
              <h2 className="font-display text-2xl text-arq-ink">{u.title}</h2>
              <p className="text-sm text-muted-foreground leading-relaxed mt-2 whitespace-pre-line">{u.message}</p>
              {u.photos && u.photos.length > 0 && (
                <div className="grid grid-cols-3 gap-2 mt-4">
                  {u.photos.map((ph, i) => <img key={i} src={ph.startsWith("http") ? ph : fileUrl(ph)} alt="" className="aspect-square object-cover rounded-md" />)}
                </div>
              )}
              <p className="text-xs text-muted-foreground mt-4">— {u.author || "Arqitek Team"}</p>
            </article>
          ))}
        </div>
      )}
    </div>
  );
}
